function buildIssueQuery(issues = []) {
  const params = new URLSearchParams();
  issues.filter(Boolean).forEach((issue) => params.append("issue", issue));
  const query = params.toString();
  return query ? `?${query}` : "";
}

async function fetchJson(authorizedFetch, path, { signal } = {}) {
  const response = await authorizedFetch(path, { signal });
  if (!response.ok) {
    let detail = "De dashboardgegevens konden niet worden opgehaald.";
    try {
      const payload = await response.json();
      detail = payload?.detail || detail;
    } catch (_) {
      // Keep the fallback message for non-JSON errors.
    }
    throw new Error(detail);
  }
  return response.json();
}

export function getLoonOpZandQuestionnaires(authorizedFetch, options = {}) {
  return fetchJson(
    authorizedFetch,
    "/api/dashboard/loon-op-zand/questionnaires/",
    options
  );
}

export function getLoonOpZandComparison(authorizedFetch, options = {}) {
  return fetchJson(
    authorizedFetch,
    "/api/dashboard/loon-op-zand/comparison/",
    options
  );
}

export function getLoonOpZandSummary(
  authorizedFetch,
  questionnaire,
  issues = [],
  options = {}
) {
  return fetchJson(
    authorizedFetch,
    `/api/dashboard/loon-op-zand/${questionnaire}/summary/${buildIssueQuery(issues)}`,
    options
  );
}

export function getLoonOpZandResults(
  authorizedFetch,
  questionnaire,
  issues = [],
  options = {}
) {
  return fetchJson(
    authorizedFetch,
    `/api/dashboard/loon-op-zand/${questionnaire}/results/${buildIssueQuery(issues)}`,
    options
  );
}

export function getLoonOpZandTextAnswers(
  authorizedFetch,
  { questionnaire, question, issue, status = "all", page = 1, signal } = {}
) {
  const params = new URLSearchParams();
  if (questionnaire && question) {
    params.set("questionnaire", questionnaire);
    params.set("question", question);
    params.set("page", String(page));
    if (issue) params.set("issue", issue);
    if (status !== "all") params.set("status", status);
  }
  const query = params.toString();
  return fetchJson(
    authorizedFetch,
    `/api/dashboard/loon-op-zand/text-answers/${query ? `?${query}` : ""}`,
    { signal }
  );
}

export async function updateLoonOpZandTextAnswer(
  authorizedFetch,
  questionnaire,
  answerId,
  question,
  value
) {
  const response = await authorizedFetch(
    `/api/dashboard/loon-op-zand/text-answers/${questionnaire}/${answerId}/`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question, value }),
    }
  );
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.detail || "Het bewerkte antwoord kon niet worden opgeslagen.");
  }
  return payload;
}
